function fieldHTML(f){
  const cls=['fld',f.half&&'half',f.third&&'third',f.q&&'q',f.type==='yn'&&'yn'].filter(Boolean).join(' ');
  return `<div class="${cls}" data-wrap="${f.id}">${inner(f)}</div>`;
}
const wrap=id=>stage.querySelector(`[data-wrap="${id}"]`);
function rerender(id){const w=wrap(id); if(w) w.innerHTML=inner(ALL[id]);}

/* ---------- Screens ---------- */
function welcome(){
  return `<div class="welcome enter">
    <div>
      <p class="kicker">Discovery questionnaire</p>
      <h1>Get every PEO <s>quoting</s> <em>competing</em> for your business.</h1>
      <p class="lede">Fill this out once. ReUp takes it to the PEOs and carriers, negotiates on your side, and brings back one side-by-side comparison.</p>
    </div>
    <div class="meta-row"><span class="pill">About 12 minutes</span><span class="pill">6 short steps</span><span class="pill">Edit anything before you submit</span></div>
    <div class="ready">
      <h2>Have these ready</h2>
      <ul>
        <li>${ICON.doc}<span>Employee census<small>Excel, using the template we emailed you</small></span></li>
        <li>${ICON.doc}<span>Latest benefits invoice<small>If you offer health insurance today</small></span></li>
        <li>${ICON.doc}<span>Plan summaries (SBCs)<small>One PDF per plan</small></span></li>
        <li>${ICON.doc}<span>Renewal notice<small>If you already have it</small></span></li>
      </ul>
    </div>
    <div class="start-row"><button type="button" class="primary" data-act="start">Start questionnaire ${ICON.arrow}</button><p class="fine">Your answers and files go straight to the ReUp team.</p></div>
  </div>`;
}
function stepScreen(i){
  const s=STEPS[i];
  return `<div class="enter">
    <div class="step-head"><p class="kicker">Step ${String(i+1).padStart(2,'0')} of ${String(TOTAL).padStart(2,'0')} · about ${s.mins} min</p><h1>${esc(s.title)}</h1><p class="lede">${esc(s.lede)}</p></div>
    ${s.note?`<div class="callout">${ICON.lock}<span>${esc(s.note)}</span></div>`:''}
    <div class="grid${s.tight?' tight':''}">${s.fields.map(fieldHTML).join('')}</div>
  </div>`;
}
function fmt(f){
  const v=S[f.id];
  if(f.id==='intl_countries') return (v&&String(v).trim())||'N/A';
  switch(f.type){
    case 'cards': return (f.opts.find(o=>o[0]===v)||[])[1]||'';
    case 'matrix':{const m=v||{},ks=Object.keys(m);const h=ks.filter(k=>m[k].now),w=ks.filter(k=>m[k].want);
      return [h.length?'Have: '+h.join(', '):'',w.length?'Want: '+w.join(', '):''].filter(Boolean).join(' · ');}
    case 'files': return (v||[]).map(x=>x.name).join(', ');
    case 'table':{const n=(v||[]).filter(r=>Object.values(r).some(x=>x&&String(x).trim())).length;return n?`${n} ${f.rowLabel.toLowerCase()}${n>1?'s':''} listed`:'';}
    case 'date': if(!v) return ''; {const d=new Date(v+'T12:00:00'); return isNaN(d)?v:d.toLocaleDateString('en-US',{month:'long',day:'numeric',year:'numeric'});}
    default: return Array.isArray(v)?v.join(', '):(v==null?'':String(v));
  }
}
function review(){
  const today=new Date().toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'});
  const secs=STEPS.map((s,i)=>{
    const rows=s.fields.filter(f=>!f.showIf||f.showIf()).map(f=>{const t=fmt(f);return `<dt>${esc(f.type==='yn'?f.label:f.label)}</dt><dd>${t?esc(t):'<span class="none">Not answered</span>'}</dd>`;}).join('');
    return `<section class="rev-sec"><div class="rev-h"><h2>${esc(s.title)}</h2><button type="button" class="link" data-goto="${i}">Edit</button></div><dl>${rows}</dl></section>`;
  }).join('');
  return `<div class="enter">
    <div class="step-head"><p class="kicker">Step ${String(TOTAL).padStart(2,'0')} of ${String(TOTAL).padStart(2,'0')} · last step</p><h1>Review & sign</h1><p class="lede">Check everything once. Tap Edit on any section to change it.</p></div>
    <div class="rev">${secs}
      <section class="sign">
        <h2>Certify and sign</h2>
        <label class="check"><input type="checkbox" id="certify"${S.certify?' checked':''}><span>I certify these answers are true and correct to the best of my knowledge, and I understand that completing this form does not bind coverage.</span></label>
        <div class="fld"><label class="lbl" for="sig">Type your full name to sign</label><input class="inp" id="sig" autocomplete="name" value="${esc(S.sig||'')}" placeholder="${esc([S.first,S.last].filter(Boolean).join(' ')||'Full name')}"></div>
        <div class="sig-pad" aria-hidden="true"><span class="sig-font" id="sigPreview">${esc(S.sig||'')}</span><span class="mono">Signed ${today}</span></div>
      </section>
    </div>
  </div>`;
}
function done(){
  return `<div class="done enter">
    <div class="done-mark">${ICON.check}</div>
    <div><p class="kicker">Submitted</p><h1>Thanks${S.first?', '+esc(S.first):''}. You're in the queue.</h1><p class="lede">Your questionnaire is with ReUp. Here is what happens next.</p></div>
    <ol class="next">
      <li><b>We review your file</b><span>We check your census and documents and follow up on anything missing.</span></li>
      <li><b>We take you to market</b><span>Your profile goes to the PEOs and carriers that fit your team, states and budget.</span></li>
      <li><b>You compare side by side</b><span>One clear comparison of cost, carriers and service, with our recommendation.</span></li>
    </ol>
    <a class="ghost" href="https://reupbenefits.com" style="text-decoration:none">Back to reupbenefits.com</a>
  </div>`;
}

/* ---------- State + rendering ---------- */
function eta(){
  if(cur<0) return `About ${STEPS.reduce((a,s)=>a+s.mins,0)} min total`;
  if(cur<STEPS.length) return `About ${STEPS.slice(cur).reduce((a,s)=>a+s.mins,0)} min left`;
  if(cur===STEPS.length) return 'Last step';
  return 'Submitted';
}
function canSubmit(){return !!S.certify&&!!(S.sig&&S.sig.trim());}
function render(){
  rail.innerHTML=RAIL.map((t,i)=>{
    const st=i<cur?'done':i===cur?'current':'todo';
    const can=i<=visited&&cur<=STEPS.length&&cur>=0;
    return `<li class="${st}"><button type="button" data-goto="${i}"${can?'':' disabled'}${i===cur?' aria-current="step"':''}><span class="num mono">${st==='done'?ICON.check:String(i+1).padStart(2,'0')}</span>${esc(t)}</button></li>`;
  }).join('');
  $('#eta').textContent=eta();
  $('#mstep').textContent=cur<0?'Welcome':cur>STEPS.length?'Submitted':`Step ${cur+1} of ${TOTAL} · ${RAIL[cur]}`;
  $('#mbar').style.width=(cur<0?0:cur>STEPS.length?100:(cur/TOTAL)*100)+'%';

  if(cur<0) stage.innerHTML=welcome();
  else if(cur<STEPS.length){stage.innerHTML=stepScreen(cur);refresh();}
  else if(cur===STEPS.length) stage.innerHTML=review();
  else stage.innerHTML=done();

  const nav=$('#nav'),next=$('#next');
  nav.hidden=(cur<0||cur>STEPS.length);
  $('#navmeta').innerHTML=cur===STEPS.length?'':'<span class="kbd">Enter ↵ to continue</span>';
  if(cur===STEPS.length){next.innerHTML='Submit '+ICON.arrow;next.disabled=!canSubmit();}
  else{next.innerHTML=(cur===STEPS.length-1?'Review answers ':'Continue ')+ICON.arrow;next.disabled=false;}
}
function refresh(){
  if(cur<0||cur>=STEPS.length) return;
  STEPS[cur].fields.forEach(f=>{const w=wrap(f.id);if(w) w.hidden=!!(f.showIf&&!f.showIf());});
}
function go(i){
  if(submitting&&i<=STEPS.length)return;
  cur=i; visited=Math.max(visited,i); render();
  window.scrollTo({top:0,behavior:reduce?'auto':'smooth'});
  const h=stage.querySelector('h1'); if(h){h.setAttribute('tabindex','-1');h.focus({preventScroll:true});}
}
function setErr(id,msg){const w=wrap(id);if(!w)return;w.classList.add('invalid');const e=$('#e-'+id,w);if(e){e.textContent=msg;e.hidden=false;}}
function touch(id){const w=wrap(id);if(w){w.classList.remove('invalid');const e=$('#e-'+id,w);if(e)e.hidden=true;}refresh();}
function isEmpty(f){
  const v=S[f.id];
  if(f.type==='table') return !(v||[]).some(r=>Object.values(r).some(x=>x&&String(x).trim()));
  if(f.type==='matrix') return false;
  if(f.type==='files') return !(v||[]).some(x=>x.status==='done');
  if(Array.isArray(v)) return !v.length;
  return v==null||String(v).trim()==='';
}
function validate(){
  let first=null;
  for(const f of STEPS[cur].fields){
    if(f.showIf&&!f.showIf()) continue;
    let msg='';
    if(f.req&&isEmpty(f)){
      msg=f.type==='files'?'Add at least one file.':f.type==='states'?'Pick at least one state.':f.type==='table'?'Add at least one entry.':['chips','seg','cards','yn'].includes(f.type)?'Choose an answer.':'This one is required.';
    } else if(f.type==='email'&&S[f.id]&&!/^\S+@\S+\.\S+$/.test(S[f.id])) msg='Enter an email like name@company.com.';
    else if(f.type==='files'&&totalBytes()>MAX_BYTES) msg='Your files add up to more than 30 MB. Remove the largest and email it to cesar@reupbenefits.com.';
    if(msg){setErr(f.id,msg);first=first||f.id;}
  }
  if(first){
    const w=wrap(first);w.scrollIntoView({behavior:reduce?'auto':'smooth',block:'center'});
    const el=w.querySelector('input:not([type=file]),select,textarea,button');if(el)el.focus({preventScroll:true});
  }
  return !first;
}
function addFiles(id,list){
  const a=S[id]||(S[id]=[]);
  Array.from(list||[]).forEach(file=>a.push({name:file.name,size:file.size,file,status:'done'}));
  rerender(id);touch(id);
}
/* ---------- Sending: PDF plus files to ReUp's mailer ---------- */
const MAX_BYTES=30*1024*1024;
const FILE_GROUPS={census:'Census',invoice:'Invoice',sbc:'SBC',renewal_docs:'Renewal'};
const mdy=v=>{if(!v)return '';const [y,m,d]=v.split('-');return m&&d&&y?`${m}/${d}/${y}`:v;};
function sentFiles(){return Object.keys(FILE_GROUPS).filter(id=>{const f=ALL[id];return !f.showIf||f.showIf();}).flatMap(id=>(S[id]||[]).map(x=>({group:FILE_GROUPS[id],item:x})));}
function totalBytes(){return sentFiles().reduce((a,x)=>a+(x.item.size||0),0);}
const toBase64=file=>new Promise((res,rej)=>{const r=new FileReader();r.onload=()=>res(String(r.result).split(',')[1]||'');r.onerror=()=>rej(r.error);r.readAsDataURL(file);});
/* ---------- Completed questionnaire as a PDF ---------- */
function buildPdf(){
  const doc=new window.jspdf.jsPDF({unit:'pt',format:'letter'});
  const W=doc.internal.pageSize.getWidth(),H=doc.internal.pageSize.getHeight(),M=48;
  const NAVY=[20,33,61],CORAL=[242,97,76],INK=[61,70,87],MUTED=[91,101,117],SUNK=[245,246,248];
  const signed=new Date().toLocaleDateString('en-US',{month:'long',day:'numeric',year:'numeric'});
  const company=S.legal||'New prospect';
  const contact=[S.first,S.last].filter(Boolean).join(' ');

  // Logo, top left: "re:" wordmark with the coral square-cap arrow, then the name
  const base=M+30;
  doc.setFont('helvetica','bold');doc.setFontSize(28);doc.setTextColor(...NAVY);
  doc.text('re:',M,base);
  const s=0.205,ox=M+doc.getTextWidth('re:')+2,oy=base-20.5;
  doc.setDrawColor(...CORAL);doc.setLineWidth(18*s);doc.setLineCap('square');doc.setLineJoin('miter');
  doc.line(ox+35*s,oy+92*s,ox+35*s,oy+24*s);
  doc.lines([[26*s,-26*s],[26*s,26*s]],ox+9*s,oy+40*s);
  doc.setFontSize(12);doc.text('ReUp Benefits',ox+70*s+10,base);

  // Title block, top right
  doc.setFontSize(13);doc.text('Discovery Questionnaire',W-M,base-10,{align:'right'});
  doc.setFont('helvetica','normal');doc.setFontSize(9);doc.setTextColor(...MUTED);
  doc.text('Submitted '+signed,W-M,base+4,{align:'right'});
  doc.setDrawColor(...CORAL);doc.setLineWidth(1.5);doc.setLineCap('butt');doc.line(M,base+16,W-M,base+16);

  // Who it is from
  let y=base+48;
  doc.setFont('helvetica','bold');doc.setFontSize(20);doc.setTextColor(...NAVY);
  doc.text(doc.splitTextToSize(company,W-2*M),M,y);
  y+=18;
  doc.setFont('helvetica','normal');doc.setFontSize(10.5);doc.setTextColor(...INK);
  doc.text([contact,S.title,S.email,S.phone].filter(Boolean).join('   |   '),M,y);
  y+=24;

  const table=(title,body,opts)=>{
    if(!body.length)return;
    doc.autoTable(Object.assign({
      startY:y,margin:{left:M,right:M,top:M,bottom:56},theme:'plain',
      head:[[{content:title.toUpperCase(),colSpan:2}]],body,
      styles:{font:'helvetica',fontSize:9.5,cellPadding:{top:5,bottom:5,left:9,right:9},textColor:NAVY,valign:'top',overflow:'linebreak'},
      headStyles:{fillColor:NAVY,textColor:[255,255,255],fontStyle:'bold',fontSize:8.5,cellPadding:{top:6,bottom:6,left:9,right:9}},
      columnStyles:{0:{cellWidth:205,textColor:MUTED}},
      alternateRowStyles:{fillColor:SUNK},
      showHead:'everyPage',rowPageBreak:'avoid'
    },opts||{}));
    y=doc.lastAutoTable.finalY+16;
  };
  const answer=f=>{
    if(f.type==='files')return (S[f.id]||[]).map(x=>x.name).join('\n');
    if(f.type==='matrix'){const m=S[f.id]||{};const have=BENEFITS.filter(b=>m[b]&&m[b].now),want=BENEFITS.filter(b=>m[b]&&m[b].want);
      return [have.length?'Has today: '+have.join(', '):'',want.length?'Wants quoted: '+want.join(', '):''].filter(Boolean).join('\n');}
    return fmt(f);
  };
  STEPS.forEach(st=>{
    const rows=st.fields.filter(f=>(!f.showIf||f.showIf())&&f.type!=='table').map(f=>[f.label.replace(/\*$/,''),answer(f)||'Not answered']);
    table(st.title,rows);
    st.fields.filter(f=>f.type==='table'&&(!f.showIf||f.showIf())).forEach(f=>{
      const rows=(S[f.id]||[]).filter(r=>Object.values(r).some(v=>v&&String(v).trim()))
        .map(r=>f.cols.map(([k,,t])=>t==='date'?mdy(r[k]):(r[k]||'')));
      if(!rows.length)return;
      doc.setFont('helvetica','bold');doc.setFontSize(9);doc.setTextColor(...MUTED);
      doc.text(f.label,M,y+4);y+=10;
      doc.autoTable({startY:y,margin:{left:M,right:M,top:M,bottom:56},theme:'plain',
        head:[f.cols.map(c=>c[1])],body:rows,
        styles:{font:'helvetica',fontSize:9.5,cellPadding:{top:5,bottom:5,left:9,right:9},textColor:NAVY},
        headStyles:{fillColor:SUNK,textColor:MUTED,fontStyle:'bold',fontSize:8.5},
        didDrawPage:()=>{}});
      y=doc.lastAutoTable.finalY+16;
    });
  });

  // Certification and signature
  if(y>H-190){doc.addPage();y=M;}
  doc.setFillColor(...NAVY);doc.rect(M,y,W-2*M,22,'F');
  doc.setFont('helvetica','bold');doc.setFontSize(8.5);doc.setTextColor(255,255,255);
  doc.text('CERTIFICATION AND SIGNATURE',M+9,y+14.5);
  y+=38;
  doc.setFont('helvetica','normal');doc.setFontSize(9.5);doc.setTextColor(...INK);
  const cert=doc.splitTextToSize('I certify these answers are true and correct to the best of my knowledge, and I understand that completing this form does not bind coverage.',W-2*M);
  doc.text(cert,M,y);y+=cert.length*12+30;
  doc.setFont('helvetica','bolditalic');doc.setFontSize(22);doc.setTextColor(...NAVY);
  doc.text(S.sig||'',M,y);
  doc.setDrawColor(...NAVY);doc.setLineWidth(0.8);doc.line(M,y+8,M+300,y+8);
  doc.setFont('helvetica','normal');doc.setFontSize(8.5);doc.setTextColor(...MUTED);
  doc.text('Signed electronically by '+(S.sig||contact)+' on '+signed,M,y+21);

  // Footer on every page
  const n=doc.getNumberOfPages();
  for(let i=1;i<=n;i++){
    doc.setPage(i);
    doc.setDrawColor(...SUNK);doc.setLineWidth(1);doc.line(M,H-40,W-M,H-40);
    doc.setFont('helvetica','normal');doc.setFontSize(8);doc.setTextColor(...MUTED);
    doc.text('ReUp Benefits  |  Confidential  |  '+company,M,H-26);
    doc.text('Page '+i+' of '+n,W-M,H-26,{align:'right'});
  }
  return doc;
}